// src/components/TopBar.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import './TopBar.css';

const TopBar: React.FC = () => {
  return (
    <header className="topbar">
      <div className="topbar-container">
        <Link to="/rj">
          <img
            src="/PREV logo v2[1]_page-0001.jpg"
            alt="Logo"
            className="topbar-logo"
          />
        </Link>
      </div>
    </header>
  );
};

export default TopBar;